import { useMutation } from '@tanstack/react-query';
import { apiService } from '../../../services/api';
import { useTranslation } from '../../../i18n';

// STD-015: write/imperative actions for the SourceCitations component. The
// page-image fetch is an on-demand user action (toggle), so it is modelled as
// a mutation rather than a query. apiService is imported here (a *.mutations.ts
// file) per STD-016. Errors are toasted by the global MutationCache handler;
// meta.errorMessage is the i18n fallback. Components that want silent failure
// (e.g. inline "not available" text) should set skipGlobalErrorToast and handle
// the error state themselves — SourceCitations uses skipGlobalErrorToast because
// failure is surfaced inline, not as a toast.

export function useGetPageImageUrl() {
  const { t } = useTranslation();
  return useMutation({
    meta: {
      errorMessage: t('chat.failedToLoadPageImage'),
      skipGlobalErrorToast: true,
    },
    mutationFn: async ({
      sourceId,
      page,
    }: {
      sourceId: string;
      page: number;
    }): Promise<{ url: string | null }> => {
      const res = await apiService.getPageImageUrl(sourceId, page);
      return { url: res.url };
    },
  });
}
